var _regeneratorRuntime = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

module.exports = getBlobURL;

var getBlob = require('stream-to-blob');

function getBlobURL(stream, mimeType) {
  var blob, url;
  return _regeneratorRuntime.async(function getBlobURL$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return _regeneratorRuntime.awrap(getBlob(stream, mimeType));

        case 2:
          blob = _context.sent;
          url = URL.createObjectURL(blob);
          return _context.abrupt("return", url);

        case 5:
        case "end":
          return _context.stop();
      }
    }
  });
}